export default __webpack_public_path__ + "static/media/outline-white1.d6b2ed40.png";